const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

let timeCounter;

export function registrationEntry() {
    const $entry = document.querySelector('.reg-entry');

    if (!$entry) return;

    const $form = $entry.querySelector('.reg-entry-form');
    const $submit = document.querySelector('.reg-continue');
    let $regEmail = document.querySelector('.reg-email');

    if (!!sessionStorage.getItem('reg')) {
        $regEmail.value = sessionStorage.getItem('reg');
    }

    $submit.addEventListener('click', (event) => {
        event.preventDefault();
        let $email = !!validateEmail($regEmail.value) ? validateEmail($regEmail.value).input : null;

        checkInvalidTimers();

        if (!$email) {
            $regEmail.parentElement.querySelector('.reg-error').innerHTML = 'Email is not correct';
            $regEmail.parentElement.querySelector('.reg-error').classList.remove('hidden');
        }

        if (!!$email) {
            let $actionPath = $form.getAttribute('data-action') + `?email=${btoa($email)}`;
            let $redirectPath = $form.getAttribute('data-follow-url');

            if (!$regEmail.parentElement.querySelector('.reg-error').classList.contains('hidden')) {
                $regEmail.parentElement.querySelector('.reg-error').innerHTML = '';
                $regEmail.parentElement.querySelector('.reg-error').classList.add('hidden');
            }

            if (!!sessionStorage.getItem('t_' + btoa($email))) {
                sessionStorage.setItem('reg', $email);
                location.href = $redirectPath;
                return;
            }

            fetch($actionPath)
                .then(response => {
                   if (response.status === 200) {
                       if (!$regEmail.parentElement.querySelector('.reg-error').classList.contains('hidden')) {
                           $regEmail.parentElement.querySelector('.reg-error').classList.add('hidden');
                       }

                       sessionStorage.setItem('reg', $email);
                       location.href = $redirectPath;
                   } else {
                       $regEmail.parentElement.querySelector('.reg-error').innerHTML = 'Unfortunately, this email address has already been used for registration. Enter another to get a reward';
                       $regEmail.parentElement.querySelector('.reg-error').classList.remove('hidden');
                   }
                });
        }
    });
}

export function registrationConfirmation() {
    const $confirmation = document.querySelector('.reg-confirmation');
    const $regEmail = sessionStorage.getItem('reg');

    if ($confirmation && !$regEmail) {
        $confirmation.querySelector('.reg-confirmation-form').parentElement.querySelector('.reg-error').innerHTML = 'Email is not correct';
        $confirmation.querySelector('.reg-confirmation-form').parentElement.querySelector('.reg-error').classList.remove('hidden');
    }

    if (!$confirmation || !$regEmail) return;

    const $regPinCode = $confirmation.querySelector('.reg-confirmation-code');
    const $submit = document.querySelectorAll('.reg-confirmation-submit');
    const $form = $confirmation.querySelector('.reg-confirmation-form');
    let $email = !!validateEmail($regEmail) ? btoa(validateEmail($regEmail).input) : null;

    countdown($email);

    $submit.forEach(_submitButton => {
        _submitButton.addEventListener('click', (event) => {
            event.preventDefault();
            let $pin = !!$regPinCode.value ? btoa($regPinCode.value) : null;

            if (!!$regPinCode) {
                let $id5 = window.__id5UserId ?? null;
                let $actionPath = _submitButton.classList.contains('with-subscription')
                    ? $form.getAttribute('data-action') + `?email=${$email}&password=${$pin}&id5=${$id5}&subscribed=true`
                    : $form.getAttribute('data-action') + `?email=${$email}&password=${$pin}&id5=${$id5}`;

                let $redirectPath = $form.getAttribute('data-follow-url');

                if (!$regPinCode.parentElement.querySelector('.reg-error').classList.contains('hidden')) {
                    $regPinCode.parentElement.querySelector('.reg-error').innerHTML = '';
                    $regPinCode.parentElement.querySelector('.reg-error').classList.add('hidden');
                }

                fetch($actionPath)
                    .then(response => {
                        if (response.status === 201) {
                            if (!$regPinCode.parentElement.querySelector('.reg-error').classList.contains('hidden')) {
                                $regPinCode.parentElement.querySelector('.reg-error').classList.add('hidden');
                            }

                            sessionStorage.removeItem('reg');
                            location.href = $redirectPath;
                        } else {
                            $regPinCode.parentElement.querySelector('.reg-error').innerHTML = 'Pin code is not correct';
                            $regPinCode.parentElement.querySelector('.reg-error').classList.remove('hidden');
                        }
                    });
            }
        });
    });

    $form.querySelector('.resend-code').addEventListener('click', (event) => {
        if ($form.querySelector('.resend-code').classList.contains('disabled')) {
            return;
        }

        event.preventDefault();
        let $actionPath = $form.getAttribute('data-resend-url') + `?email=${$email}`;

        $regPinCode.value = '';
        countdown($email);

        fetch($actionPath)
            .then(response => {
                if (response.status === 200) {
                    if (!$regPinCode.parentElement.querySelector('.reg-error').classList.contains('hidden')) {
                        $regPinCode.parentElement.querySelector('.reg-error').classList.add('hidden');
                    }
                }
            });
    });
}

function countdown(id) {
    const timer = 1;
    let key = 't_' + id;
    let countdownTime = null;
    let _now = new Date();

    if (!!sessionStorage.getItem(key)) {
        countdownTime = parseInt(sessionStorage.getItem(key));

        if (countdownTime - (new Date().getTime()) <= 0) {
            sessionStorage.removeItem(key);
            clearInterval(timeCounter);
            timeCounter = null;
            document.getElementById('timer').innerHTML = '';
        }
    } else {
        countdownTime = _now.setMinutes(_now.getMinutes() + timer);
        sessionStorage.setItem(key, countdownTime.toString());
    }

    document.getElementById('timer').classList.remove('hidden');
    document.querySelector('.reg-confirmation .resend-code').classList.add('disabled');

    if (!!timeCounter) {
        clearInterval(timeCounter);
        timeCounter = null;
        document.getElementById('timer').innerHTML = '';
    }

    timeCounter = setInterval(() => {
        let _moment = new Date().getTime();
        let distance = countdownTime - _moment;
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        document.getElementById('timer').innerHTML = minutes + ':' + (seconds < 10 ? '0' + seconds : seconds);

        if (distance <= 0) {
            clearInterval(timeCounter);
            sessionStorage.removeItem(key);
            document.getElementById('timer').innerHTML = '';
            document.getElementById('timer').classList.add('hidden');
            document.querySelector('.reg-confirmation .resend-code').classList.remove('disabled');
        }
    }, 1000);
}

function checkInvalidTimers() {
    for (let i = 0; i < sessionStorage.length; i++) {
        const _key = sessionStorage.key(i);
        const _value = sessionStorage.getItem(_key);

        if (_key.includes('t_')) {
            const _countdownTime = parseInt(sessionStorage.getItem(_key));

            if (_countdownTime - (new Date().getTime()) <= 0) {
                sessionStorage.removeItem(_key);
            }
        }
    }
}